module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDklEQVQ4T6WTjVHCAAyFPybADWQDYAJlAzYAJoARcAJ1A9nAEdzAdgJgAzeQ+3pJrxaK/OSOo9fmvby8JD2OYwAsgWdgBPwABfAFbIBdE9Jr4d8CXAZA4AMg6RToA+a8JK5JYLKJK+DjhDJf+W0dJP6TBLLOQ7ZE58IituWvIvDFFlicqdwkPCKwehr2T/Hq8yfwCExUoYJ02P4uCU11Ir+SSOBDU74SX8P9LkJJHHHRRWBbJnWFRWyjvKUFwd/AXu8ksNoTML7EgDBREo2vTLx7jBZWxSxGc/UipXKBGuM4PZpT4bY6ofdY6XqVMzmPyYtzYVKNI/OYbFdwvTPta5QoD0qThsGc12mBP+d8APmDQNDsX91tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/esc.png
// module id = D2Br
// module chunks = 50